import { path, pathOr, isNil } from 'ramda';

import {
  FETCH_USER_INFO,
  FETCH_USER_INFO_SUCCESS,
  FETCH_USER_INFO_ERROR,
  FETCH_USER_BALANCE_ERROR,
  START_RECEIVE_DATA,
  RECEIVE_DATA,
  UPDATE_MNP_STATUS_VISIBILITY,
  OPEN_VALIDATION_PD_POPUP,
  CLOSE_VALIDATION_PD_POPUP,
  FAIL_VALIDATION_PD_REQUEST,
  SUCCESS_VALIDATION_PD_REQUEST,
  START_VALIDATION_PD_REQUEST,
  SET_ALLINONE_VALUE,
  SET_PARTNERSHIP_TARIFF_STATUS,
  FETCH_FAMILY_DATA,
  FETCH_FAMILY_LOADING,
  FETCH_FAMILY_ERROR,
  FETCH_USIS_RESULT_POPUP_DATA,
  OPEN_USIS_RESULT_POPUP,
  CLOSE_USIS_RESULT_POPUP,
  SET_USIS_RESULT_STEP,
  FETCH_USER_TARIFFS_BLOCK,
} from './constants';

import { multiconvergenceOfferPopupReducer }
from './components/MulticonvergenceOfferPopup/reducers/MulticonverhenceOfferPopup';

const initialState = {
  balanceNotification: {},
  status: {},
  profileSummary: {},
  balance: {},
  accumulators: {},
  services: {},
  additionalBalances: {},
  sasBalance: {},
  associatedAccounts: {},
  internetExtension: {},
  guaranteePayment: {},
  personalData: {},
  isMnpStatusHidden: false,
  isUserInfoFetching: true,
  isUserBalanceFetching: false,
  userInfoFetchingError: null,
  isValidationPDPopupOpen: false,
  validationPDRequestStatus: 'initial',
  validationPDSuccessText: '',
  allInOne: {},
  isPartnershipTariffConnected: false,
  personalFamily: {
    isLoading: false,
    isError: false,
  },
  isUsisResultPopupOpen: false,
  isUsisResultPopupDataFetching: true,
  usisResultStep: '',
  usisResultPopup: {},
  tariffsBlock: {},
};

function getRcRateByRcRateText(tariffRcRateText) {
  return Number.parseFloat(tariffRcRateText.replace(',', '.'));
}

export default function app(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_INFO:
      return {
        ...state,
      };

    case FETCH_USER_INFO_SUCCESS: {
      const tariffRcRateText = path(['data', 'profileSummary', 'data', 'tariffRcRateText'], action);
      const balance = path(['data', 'balance', 'data', 'balance'], action);

      const rcRate = tariffRcRateText && getRcRateByRcRateText(tariffRcRateText);
      const amountToPay = !isNil(rcRate) && !isNil(balance) && (rcRate - balance);

      const profileSummaryData = pathOr(state.profileSummary.data, ['data', 'profileSummary', 'data'], action);

      return {
        ...state,
        ...action.data,
        profileSummary: {
          data: {
            ...profileSummaryData,
            rcRate,
            amountToPay,
          },
        },
        isUserInfoFetching: false,
        userInfoFetchingError: null,
        isUserBalanceFetching: false,
      };
    }
    case FETCH_USER_INFO_ERROR:
      return {
        ...state,
        isUserInfoFetching: false,
        userInfoFetchingError: action.error,
      };
    case FETCH_USER_BALANCE_ERROR:
      return {
        ...state,
        isUserBalanceFetching: true,
      };
    case START_RECEIVE_DATA:
      return {
        ...state,
        sasBalance: {
          ...state.sasBalance,
          isLoading: true,
        },
      };
    case RECEIVE_DATA:
      return { ...state, ...action.data };
    case UPDATE_MNP_STATUS_VISIBILITY:
      return {
        ...state,
        isMnpStatusHidden: action.data,
      };
    case OPEN_VALIDATION_PD_POPUP:
      return {
        ...state,
        isValidationPDPopupOpen: true,
      };
    case SET_PARTNERSHIP_TARIFF_STATUS:
      return {
        ...state,
        isPartnershipTariffConnected: action.payload,
      };
    case CLOSE_VALIDATION_PD_POPUP:
      return {
        ...state,
        isValidationPDPopupOpen: false,
      };
    case SUCCESS_VALIDATION_PD_REQUEST:
      return {
        ...state,
        validationPDRequestStatus: 'success',
        validationPDSuccessText: action.payload.text,
      };
    case START_VALIDATION_PD_REQUEST:
      return {
        ...state,
        validationPDRequestStatus: 'requested',
        validationPDSuccessText: '',
      };
    case FAIL_VALIDATION_PD_REQUEST:
      return {
        ...state,
        validationPDRequestStatus: 'fail',
        validationPDSuccessText: '',
      };
    case SET_ALLINONE_VALUE:
      return multiconvergenceOfferPopupReducer(state, action);
    case FETCH_FAMILY_DATA:
      return {
        ...state,
        personalFamily: {
          ...state.personalFamily,
          info: action.payload.sharing.info,
          personalInfo: action.payload.sharing.personalInfo,
        },
      };
    case FETCH_FAMILY_LOADING:
      return {
        ...state,
        personalFamily: {
          ...state.personalFamily,
          isLoading: action.payload,
        },
      };
    case FETCH_FAMILY_ERROR:
      return {
        ...state,
        personalFamily: {
          ...state.personalFamily,
          isError: true,
        },
      };
    case SET_USIS_RESULT_STEP:
      return {
        ...state,
        usisResultStep: action.payload,
      };
    case FETCH_USIS_RESULT_POPUP_DATA:
      return {
        ...state,
        isUsisResultPopupDataFetching: false,
        usisResultPopup: {
          ...state.usisResultPopup,
          ...action.payload,
        },
      };
    case OPEN_USIS_RESULT_POPUP:
      return {
        ...state,
        isUsisResultPopupOpen: true,
      };
    case CLOSE_USIS_RESULT_POPUP:
      return {
        ...state,
        isUsisResultPopupOpen: false,
      };
    case FETCH_USER_TARIFFS_BLOCK:
      return {
        ...state,
        tariffsBlock: action.payload,
      };
    default:
      return state;
  }
}
